/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Le carrefour de l'amitié",
      "Fais‑toi de nouveaux amis avec Bumble For Friends | Bumble",
      "Télécharger sur l'App Store",
      "Télécharger sur Google Play",
      "Un espace dédié pour se faire de nouveaux amis",
      "Rencontre des personnes qui cherchent de vraies connexions à proximité.",
      "Trouve des amis pour toutes les étapes de ta vie",
      "Tu viens d'arriver en ville ? Tu veux un nouveau départ ? Tes nouveaux amis t'attendent.",
      "Un espace sûr pour tous",
      "Bienvenue dans un coin d'Internet bienveillant, où tu peux être toi-même.",
      "Télécharger l'appli",
      "Rencontre en personne des gens qui partagent tes centres d'intérêt !",
      "Fais la connaissance d'un nouveau groupe de personnes avec Plans sur Bumble For Friends",
      "Tu as reçu une invitation pour Plans",
      "Plans est une nouvelle fonction de Bumble For Friends qui te permet de créer et de rejoindre des groupes pour te faire de nouveaux amis près de chez toi",
      "Gérer les cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "jours"
            ],
            "singular": [
                  "jour"
            ]
      },
      "hour": {
            "plural": [
                  "heures"
            ],
            "singular": [
                  "heure"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "mois"
            ],
            "singular": [
                  "mois"
            ]
      },
      "second": {
            "plural": [
                  "secondes"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "ans"
            ],
            "singular": [
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
